
import {Component, Vue} from "vue-property-decorator";
import {DateTime} from "luxon";
import {Pattern} from "@/addons/Pattern";
import {SancionService} from "@/services/SancionService";
import SancionShow from "@/views/sanciones/SancionShow.vue";
import SancionNew from "@/views/sanciones/SancionNew.vue";
import {Alert} from "@/addons/Alert";
import SancionObservar from "@/views/sanciones/observar.vue";
import router from "@/router";
import {bincardStore} from "@/store/bincardStore";
import {BincardService} from "@/services/BincardService";
import {materialStore} from "@/store/materialStore";


@Component({
  name: "BincardIndex",
  components: {SancionObservar, SancionNew, SancionShow},
})
export default class SancionIndex extends Vue {
  private patterns = Pattern;
  search = null
  private bincardStore = bincardStore();
  private materialStore = materialStore();
  private bincardService = BincardService.getInstance();
  private fechaInicial = DateTime.now().toFormat("yyyy-MM-dd");
  private fechaFinal = DateTime.now().toFormat("yyyy-MM-dd");
  private sancionSeleccionada: any = null;

  private isObservar = false;

  grupo_id = "Todos";

  get grupoMaterial(): any {
    return this.materialStore.grupoMaterial;
  }

  get materiales(): any[] {
    return this.bincardStore.materialesListado;
  }

  get loading(): boolean {
    return this.bincardStore.loading;
  }

  get pagination(): any {
    return this.bincardStore.pagination;
  }

  get showDialogSancion(): boolean {
    return this.bincardStore.showDialogSancion;
  }


  mounted() {
    this.listar();
  }


  listar() {
    this.bincardStore.materialesListado = [];
    const data = {
      fechaInicial: this.fechaInicial,
      fechaFinal: this.fechaFinal,
      search: this.search,
      grupo: this.grupo_id,
      page: this.pagination.current_page
    };
    this.bincardService.index(data);
    this.bincardStore.saldoInicial = [];
    this.bincardStore.sumSalidas = [];
    this.bincardStore.sumIngresos = [];
    this.bincardStore.bincard = [];
  }

  showBincard(material:any){
    router.push({name: 'showBincardPeps', params: {materialEdit: material}})
  }
}
